/**
 * @file Marks a charge as paid directly to the owner through `charges/:id/paidToOwner` and confirms it in a snackbar.
 * A refusal the paid-to-owner route is known to send opens the refusal dialog with that path's texts.
 */
import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence, ExpectedErrors } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

const EXPECTED_ERRORS: ExpectedErrors = {
  financial_operations_were_blocked: { titleKey: "refusal-title-paid-to-owner", bodyKey: "refusal-body-financial-processing-busy" },
  be_unauthorized: { titleKey: "refusal-title-paid-to-owner", bodyKey: "refusal-body-charge-not-found" },
  charge_already_paid_directly_to_owner: { titleKey: "refusal-title-paid-to-owner", bodyKey: "refusal-body-already-paid-directly" },
  charge_already_is_fully_paid: { titleKey: "refusal-title-paid-to-owner", bodyKey: "refusal-body-charge-fully-paid" }
};

export default function* chargePaidToOwner(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_PAID_TO_OWNER_REQUEST
    });

    yield call(Http.post, `charges/${action.payload?.charge?.id}/paidToOwner`);

    yield put({
      type: Constants.GLOBAL_CHARGE_PAID_TO_OWNER_SUCCESS
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-charge-updated-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action, EXPECTED_ERRORS);

    yield put({
      type: Constants.GLOBAL_CHARGE_PAID_TO_OWNER_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargePaidToOwner() {
  yield takeEvery(Constants.GLOBAL_CHARGE_PAID_TO_OWNER_START, chargePaidToOwner);
}
